(function () {
	'use strict';

	angular.module('qbePortal').controller('QBCombinedValidationController', QBCombinedValidationController);

	QBCombinedValidationController.$inject = ['$scope', 'validationService', 'Util', 'gtmService'];

	function QBCombinedValidationController($scope, validationService, util, gtmService) {
		var vm = this;
		var errorsByField = [];

		$scope.$on('reset-field-errors', resetFieldErrors);
		function resetFieldErrors() {
			validationService.clearAllErrors();
			errorsByField = [];
		}

		vm.fetchErrorsByField = function () {
			var errors = validationService.getAllErrors();
			if (!errors) return [];

			for (var input in errors) {
				// console.log('errors' , errors) ;

				var error = errors[input];
				var element = error.element;
				var fieldLabel = error.label;
				var fieldErrors = error.errors;
				var ngModel = error.input;
				for (var errorType in fieldErrors) {
					var msg = fieldErrors[errorType];

					if (error.wildcard) {
						var wildcardValue = error.element.scope().$eval(error.wildcard);
						fieldLabel = processWildCard(fieldLabel, wildcardValue);
					}

					var wildcardErrorAttr = element.attr('wildcard-' + errorType);
					if (typeof wildcardErrorAttr != 'undefined') {
						wildcardErrorAttr = error.element.scope().$eval(wildcardErrorAttr);
						msg = processWildCard(msg, wildcardErrorAttr);
					}

					errorsByField.push({
						name: element.attr('name'),
						label: fieldLabel,
						id: element.attr('id'),
						errorType: errorType,
						viewValue: element.$viewValue,
						validationMessage: msg,
						section: ngModel.$$parentForm
					});

				}
			}
			//TODO: call function to track event to gtm
			processGTM(errorsByField);
			return errorsByField;
		}

		vm.hasErrors = function () {
			if (errorsByField.length == 0)
				errorsByField = vm.fetchErrorsByField();

			return errorsByField.length > 0;
		}

		vm.showInView = function (error) {
			var offset = $('#' + error.id).offset();

			$('html, body').animate({
				scrollTop: (offset.top - 50),
				scrollLeft: offset.left
			});
		}

		vm.getErrorsByField = function () {

			return errorsByField;
		}

		function processWildCard(targetString, wildcardValue) {
			if (typeof wildcardValue == 'string' || typeof wildcardValue == 'undefined') {
				targetString = util.stringFormat(targetString, wildcardValue);
			} else {
				// Handle multiple wildcard
				var argArr = [];
				argArr.push(targetString);
				argArr = argArr.concat(wildcardValue);
				targetString = util.stringFormat.apply(null, argArr);
			}
			return targetString;
		}

		/*
		* dd-4003 - push to gtm data layer on field errors
		* param = errors by field
		*/
		function processGTM(errorsByField) {
			if (errorsByField.length > 0) {				
				angular.forEach(errorsByField, function (errorsByField, index) {										
					var errorByFieldLabel = errorsByField.label;
					var errorEvent = gtmService.createGtmValidationErrorEvent(errorByFieldLabel);
					gtmService.trackEvent(errorEvent, 'formValidationError');
				});				
			}			
		}
	}

	angular.module('qbePortal').component('qbCombinedValidation', {
		templateUrl: '/ngviews/components/qbCombinedValidation.html',
		controller: QBCombinedValidationController,
		controllerAs: 'vm',
		bindings: {
			formSelector: '<',
			show: '<',
		}
	});
})();
